import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { LoginPageComponent } from './login-page/login-page.component';
import { ForgetPasswordComponent } from './forget-password/forget-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { UnsubscribeComponent } from './unsubscribe/unsubscribe.component';

@NgModule({
  declarations: [
    LoginPageComponent,
    ForgetPasswordComponent,
    ResetPasswordComponent,
    UnsubscribeComponent,
  ],
  imports: [CommonModule, SharedModule],
})
export class AuthModule {}
